function startsWith(string, target) {
  return String(string).slice(0, target.length) === target;
}

const handleWithExpandedError = async (res) => {
  const contentType = res.headers.get('Content-Type');
  const isJson = startsWith(contentType, 'application/json');
  const body = await res[isJson ? 'json' : 'text']();
  const { status } = res;

  return res.ok
    ? Promise.resolve(body)
    : Promise.reject(Object.assign(new Error(`${res.statusText} (${res.url})`), { body, status }));
};

export default handleWithExpandedError;
